import type { ColumnDef, RowData } from "@tanstack/react-table";

/** Derives initial column visibility from each column's meta.defaultVisible (default: true). */
export function getInitialVisibility<TData extends RowData>(
  columns: ColumnDef<TData, unknown>[],
): Record<string, boolean> {
  return Object.fromEntries(
    columns
      .filter((col) => col.enableHiding !== false && col.meta?.label)
      .flatMap((col) => {
        const id = (col as { accessorKey?: string }).accessorKey ?? col.id;
        if (!id) return [];
        return [[id, col.meta?.defaultVisible ?? true] as const];
      }),
  );
}

/** Returns the initial column order as an array of all column IDs. */
export function getInitialOrder<TData extends RowData>(
  columns: ColumnDef<TData, unknown>[],
): string[] {
  return columns
    .map((col) => (col as { accessorKey?: string }).accessorKey ?? col.id ?? "")
    .filter(Boolean);
}
